var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 33,
    viewBox: "0 0 21 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-certificate-1825937 1",
    clipPath: "url(#clip0_745_1431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.575 22.431C9.36371 22.431 8.23264 22.0834 7.27409 21.4844L6.75781 32.0347L9.95357 29.1765C10.2229 28.9254 10.6246 28.8788 10.9858 29.0594C11.0443 29.0886 11.0986 29.1255 11.1473 29.1691L14.3512 32.0348L13.8362 21.51C12.8862 22.0936 11.7694 22.431 10.575 22.431Z",
    fill: "url(#paint0_linear_745_1431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.4768 20.8744C14.067 20.3756 15.7625 17.8715 15.2637 15.2812C14.7649 12.691 12.2608 10.9955 9.67051 11.4943C7.08027 11.9931 5.38482 14.4973 5.88361 17.0875C6.38241 19.6777 8.88656 21.3732 11.4768 20.8744Z",
    fill: "url(#paint1_linear_745_1431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.48461 27.0597H5.52623L5.8582 20.2756C4.90481 19.1785 4.32562 17.7479 4.32562 16.1836C4.32562 12.7388 7.12826 9.93612 10.5732 9.93612C14.0182 9.93612 16.8207 12.7388 16.8207 16.1836C16.8207 17.7691 16.226 19.2175 15.2495 20.3203L15.5793 27.0597H18.5181C19.7352 27.0597 20.7254 26.0696 20.7254 24.8525V3.82934C20.7254 2.61225 19.7352 1.62207 18.5181 1.62207H2.48461C1.26752 1.62207 0.277344 2.61225 0.277344 3.82934V24.8525C0.277344 26.0696 1.26752 27.0597 2.48461 27.0597Z",
    fill: "url(#paint2_linear_745_1431)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_745_1431",
    x1: 10.5545,
    y1: 21.4844,
    x2: 10.5545,
    y2: 32.0348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4056DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_745_1431",
    x1: 9.67052,
    y1: 11.4943,
    x2: 11.4768,
    y2: 20.8744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4056DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_745_1431",
    x1: 10.5014,
    y1: 1.62207,
    x2: 10.5014,
    y2: 27.0597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4056DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746A3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_745_1431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 32,
    fill: "white",
    transform: "translate(0 0.914062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportCardIcon);
export default __webpack_public_path__ + "static/media/reportCardIcon.fcf7b136829b507a058582b6d06162ff.svg";
export { ForwardRef as ReactComponent };